import {
  UNLEASH_FEATURE_NAME,
  type InitialState
} from '@schibsted-nmp/advertising-shared';
import { Script } from '@client/core/utils/Script.js';
import { Scripts as RelevantYieldScripts } from '@client/core/relevantDigital/Scripts.js';
import { isFeatureEnabled } from '@client/core/atoms/unleashFeatures.js';

export namespace Scripts {
  export function* get(
    initialState: InitialState,
    excludeDependencies = true
  ): Generator<Script, void, void> {
    if (!isEnabled(initialState)) return;

    yield {
      name: 'gam',
      src: 'https://securepubads.g.doubleclick.net/tag/js/gpt.js',
      defer: true
    };

    if (excludeDependencies) return;

    yield* RelevantYieldScripts.get(initialState);
  }

  export function getServerHtml(initialState: InitialState) {
    if (!isEnabled(initialState)) return '';

    return Array.from(
      Script.getServerHtml(
        initialState,
        get,
        [
          `<script>(()=>{(window.googletag??={}).cmd??=[]})();</script>`,
          RelevantYieldScripts.getServerHtml(initialState)
        ].join('\n')
      )
    ).join('\n');
  }

  export function isEnabled({ unleashFeatures, config }: InitialState) {
    if (!unleashFeatures[UNLEASH_FEATURE_NAME.enableGam]?.enabled) {
      return false;
    }

    if (!config.adServer.gam) return false;

    if (isFeatureEnabled(UNLEASH_FEATURE_NAME.disableAdn)) return true;

    return true;
  }
}
